import { createDisposalBin, listenEvent } from 'maverick.js/std';
import React from "react";
export function useMouseEnter(el: Element | null) {
  const [isMouseEnter, setIsMouseEnter] = React.useState(false);
  React.useEffect(() => {
    if (!el) return;
    const disposal = createDisposalBin();
    disposal.add(listenEvent(el, 'mouseenter', () => setIsMouseEnter(true)), listenEvent(el, 'mouseleave', () => setIsMouseEnter(false)));
    return () => disposal.empty();
  }, [el]);
  return isMouseEnter;
}
export function useFocusIn(el: Element | null) {
  const [isFocusIn, setIsFocusIn] = React.useState(false);
  React.useEffect(() => {
    if (!el) return;
    const disposal = createDisposalBin();
    disposal.add(listenEvent(el, 'focusin', () => setIsFocusIn(true)), listenEvent(el, 'focusout', () => setIsFocusIn(false)));
    return () => disposal.empty();
  }, [el]);
  return isFocusIn;
}
export function useActive(el: Element | null) {
  const isMouseEnter = useMouseEnter(el),
    isFocusIn = useFocusIn(el),
    prevMouseEnter = React.useRef(false);
  if (prevMouseEnter.current && !isMouseEnter) return false;
  prevMouseEnter.current = isMouseEnter;
  return isMouseEnter || isFocusIn;
}